import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import zihuaLogo from "../../../assets/pdfs/zihua-logo.png";
import image from "../../../assets/pdfs/image38.png";
import header from "../../../assets/pdfs/Mask group.png";
//import gradient from "../assets/background2.png";
import gradient from "../../../assets/pdfs/background2.png";

// Estilos para el documento PDF
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  sectionHeader: {
    height: "15%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "8%",
    justifyContent: "center",
    alignItems: "center",
  },
  headerBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  logo: {
    position: "absolute",
    width: "100px",
    height: "100px",
  },
  content: {
    height: "35%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 10,
    marginVertical: 20,
    paddingHorizontal: 40,
  },
  detailContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  detailItem: {
    width: "50%",
    padding: 5,
    paddingVertical: 10,
  },
  label: {
    color: "#0293B0",
    fontWeight: "bold",
  },
  textDescription: {
    fontSize: "10px",
  },
  title: {
    marginBottom: 20,
    fontSize: "20px",
  },
  contentImage:{
    marginTop: 20,
  },
  contentText: {
    position: "absolute",
    right: 0,
    width: "45%",
    marginRight:10,
    marginTop:20,
    textAlign: "right",
  },
  textImage: {
    color: "white",
    fontSize: "16px",
    fontWeight: "normal",
  },
  boldText: {
    fontWeight: "bold",
  },
  textFooter: {
    color: "white",
    marginVertical: 5,
  },
});

// Componente que genera el PDF
const LandDetailsPdf = (props) => (
  <Document>
  <Page size="A4" style={styles.page}>
    <View style={styles.sectionHeader}>
      <Image src={gradient} style={styles.headerBackground} />
      <Image src={header} style={styles.headerBackground} />
      <Image src={zihuaLogo} style={styles.logo} />
    </View>
    <View style={styles.content}>
      <Text style={styles.title}>Detalles:</Text>
      <View style={styles.detailContainer}>
        <View style={styles.detailItem}>
          <Text style={styles.label}>Nombre:</Text>
          <Text style={styles.textDescription}>{props?.name || ""}</Text>
        </View>
        <View style={[styles.detailItem, {paddingLeft: 35}]}>
          <Text style={styles.label}>Medidas:</Text>
          <Text style={styles.textDescription}>{props?.media || ""}</Text>
        </View>
        <View style={styles.detailItem}>
          <Text style={styles.label}>Enganche:</Text>
          <Text style={styles.textDescription}>$10,000.00</Text>
        </View>
        <View style={[styles.detailItem, {paddingLeft: 35}]}>
          <Text style={styles.label}>Precio:</Text>
          <Text style={styles.textDescription}>{props?.price || ""}</Text>
        </View>
        <View style={styles.detailItem}>
          <Text style={styles.label}>Descuento:</Text>
          <Text style={styles.textDescription}>0%</Text>
        </View>
        <View style={[styles.detailItem, {paddingLeft: 35}]}>
          <Text style={styles.label}>Descripción:</Text>
          <Text style={styles.textDescription}>N/A</Text>
        </View>
        <View style={styles.detailItem}>
          <Text style={styles.label}>Mensualidad:</Text>
          <Text style={styles.textDescription}>120 meses</Text>
        </View>
      </View>
    </View>

    <View style={styles.contentImage}>
      <Image src={image} />
      <View style={styles.contentText}>
        <Text style={styles.textImage}>
          Una de las principales ventajas que te ofrecemos es poder pagar tu
          terreno en{" "}
          <Text style={styles.boldText}>
            cómodos pagos mensuales sin intereses
          </Text>{" "}
          por hasta 10 años.
        </Text>
      </View>
    </View>

    <View style={styles.sectionFooter}>
      <Image src={gradient} style={styles.headerBackground} />
      <Text style={styles.textFooter}>zihuainvest.com</Text>
      <Text style={styles.textFooter}>info@zihuainvest.com</Text>
    </View>
  </Page>
</Document>
);

export default LandDetailsPdf;
